import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { apiV1Endpoint } from "../../../../api/v1";

export const useGetLeaseAmendmentPendingRequest = <T,>(leaseAmendmentRequest: boolean | string | number) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(apiV1Endpoint + "/booking", {
        params: { leaseAmendmentRequest },
      });

      setData(response.data?.result);
      setError(null);
    } catch (err: any) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [leaseAmendmentRequest]);
  // ❗ re-run callback when param changes

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};
